import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";

export default function ProtectedRoute({ children }) {
  const { isAuthed, ready } = useAuth();
  const loc = useLocation();
  if (!ready) {
    return (
      <div className="auth-loading" data-testid="auth-loading">
        <div className="auth-spinner" />
        <span>Memverifikasi sesi…</span>
      </div>
    );
  }
  if (!isAuthed) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }
  return children;
}
